import React, { useState } from "react";

import logo from "./assets/img/logo.svg";
import {
  PinInput,
  PinInputField,
  useToast,
  Flex,
  HStack,
  Image,
} from "@chakra-ui/react";
import {useNavigate } from "react-router-dom";

function Login({ setIsAuthenticated }) {
    const [pin, setPin] = useState("");
    const navigate = useNavigate();
    const toast = useToast();
  
    const handlePinChange = (value) => {
      setPin(value);
      if (value.length === 4) {
        handleSubmit(value); // Trigger login when 4 digits are entered
      }
    };
  
    const handleSubmit = (enteredPin) => {
      const correctPin = "2184";
  
      if (enteredPin === correctPin) {
        setIsAuthenticated(true);
        navigate("/");
        toast({
          title: "Login successful",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Incorrect PIN",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      }
    };

    return (
      <Flex
        spacing={4}
        align="center"
        direction={"column"}
        h={"100dvh"}
        w={"100vw"}
        justifyContent={"flex-start"}
        py={48}
        alignItems={"center"}
        gap={24}
      >
        <Image src={logo} borderRadius={4} width={82} />
        
        <Flex direction={"column"} gap={4}>
        <h3>Enter PIN code</h3>
        <HStack>
          <PinInput value={pin} onChange={handlePinChange} otp size={"lg"} colorScheme="brand" mask>
            <PinInputField />
            <PinInputField />
            <PinInputField />
            <PinInputField />
          </PinInput>
        </HStack>
        </Flex>
      </Flex>
    );
  }

  
  export default Login;